import styled from "styled-components";
import { Fragment } from "react";

import StrapiRichText from "../../../components/StrapiRichText";
import { Section, Heading, Container } from "./Section";
import Header from "../home/Header";
import Footer from "../home/Footer";
import {
  weight,
  type,
  space,
  leading,
  font,
  color,
} from "../../../styles/tokens";

/* The shared body of /hebe/privacy-policy and /hebe/terms-of-service.
 *
 * The two pages were 101 lines each and byte-identical apart from six identifier renames — every
 * styled component, the whole render tree and the CMS-with-translation-fallback logic, duplicated.
 * They now differ only in the props they pass here.
 *
 * Title and the noindex directive are server-rendered from Hebe::SeoPresenter#legal, so the
 * directive does not depend on JavaScript running.
 */

const Prose = styled.div`
  margin-bottom: ${space[7]};

  h2 {
    margin: 0 0 ${space[3]};
    font-family: ${font.display};
    font-size: ${type.h3};
    font-weight: ${weight.regular};
    color: ${color.ink};
  }

  p {
    margin: 0 0 ${space[4]};
    font-size: ${type.base};
    line-height: ${leading.relaxed};
    color: ${color.ink700};
  }
`;

const LastUpdated = styled.p`
  margin: 0 0 ${space[7]};
  font-size: ${type.sm};
  color: ${color.ink500};
`;

const LegalPage = (props) => {
  const { document: doc, fallback } = props;

  const title = doc?.title || fallback.title;
  const lastUpdated = doc?.last_updated_at || fallback.lastUpdated;
  const sections = doc?.sections?.length
    ? doc.sections
    : fallback.sections.map((section) => ({
        title: section.heading,
        content: null,
        _body: section.body,
      }));

  return (
    <Fragment>
      <Header forceScrolled />
      <main id="main">
        <Section>
          <Container $width="narrow">
            <Heading as="h1" $size="h1">
              {title}
            </Heading>
            <LastUpdated>{lastUpdated}</LastUpdated>
            {sections.map((section) => (
              // Keyed by heading rather than array index: these lists come from the CMS and are
              // reordered by editors.
              <Prose key={section.title}>
                <h2>{section.title}</h2>
                {section.content ? (
                  <StrapiRichText content={section.content} />
                ) : (
                  <p>{section._body}</p>
                )}
              </Prose>
            ))}
          </Container>
        </Section>
      </main>
      <Footer />
    </Fragment>
  );
};

export default LegalPage;
